import React, { useContext, useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { LangContext } from '../contexts/langContext';
import { SocialContext } from '../contexts/socialContext';
import { StateContext } from '../contexts/stateContext';

export function WithURLparams(props) {
  const context = { ...useContext(SocialContext), ...useContext(StateContext), ...useContext(LangContext) }

  let urlParams = new URLSearchParams(window.location.search);
  const [searchParams] = useSearchParams();
  const queryString = searchParams.toString().replace('%3A', ':').replace('%2F', '/');

  const location = useLocation();

  const lang = urlParams.get('ln') && context.languages.includes(urlParams.get('ln')) ? urlParams.get('ln') : '';


  const removeLanguageParam = () => {
    const hash = location.hash;
    const params = new URLSearchParams(hash.slice(1)); // Remove the leading '#'
    params.delete('ln');
    const newHash = params.toString();
    window.history.replaceState(null, '', `${location.pathname}${location.search}${newHash ? `#${newHash}` : ''}`);
  };

  useEffect(() => {
    const hash = location.hash;
    const params = new URLSearchParams(hash.slice(1)); // Remove the leading '#'
    const languageParam = params.get('ln');
    if (languageParam !== context.language && context.languages.includes(languageParam)) {
      context.setLanguage(languageParam)
    }
    removeLanguageParam()
  }, [location]);


  const addProps = {}

  return (
    <>
      {React.cloneElement(props.children, { ...addProps })}
    </>
  )
}